import React, { Component } from 'react';
import UI from '../ui';
import Utils from '../utils';
import { ShippingInputs } from './ShippingInputs.component';

const { DimensionsField, WeightField } = UI;
const { Logger } = Utils;

class Header extends Component {
	constructor(props) {
		super(props);

		const { ratingData } = props;

		this.state = {
			...ratingData,
			toState:
				ratingData.toCountryCode === 'US'
					? ratingData.toState
					: ratingData.toProvince || ratingData.toCountryCode,
		};
	}

	onChangeDimensions = updatedState => {
		const { onHeaderInputChange } = this.props;
		const dimensions = {
			length: updatedState.length,
			width: updatedState.width,
			height: updatedState.height,
		};

		this.setState(dimensions, () => {
			onHeaderInputChange(dimensions);
		});

		Logger.logToServer({
			category: 'ra_input_field_change',
			ui_element: 'dimensions',
			value: dimensions,
		});
	};

	onChangeWeight = updatedState => {
		const { onHeaderInputChange } = this.props;
		const weight = {
			weightLb: updatedState.pounds,
			weightOz: updatedState.ounces,
		};

		this.setState(weight, () => {
			onHeaderInputChange(weight);
		});

		Logger.logToServer({
			category: 'ra_input_field_change',
			ui_element: 'weight',
			value: weight,
		});
	};

	render() {
		const {
			fromCity,
			fromState,
			toCity,
			toState,
			weightOz,
			weightLb,
			length,
			width,
			height,
			fromZip,
		} = this.state;
		const shipFrom =
			fromCity.length === 0 || fromState.length === 0
				? fromZip
				: `${fromCity}, ${fromState}`;
		const shipTo = toCity ? `${toCity}, ${toState}` : '';
		const weight = { pounds: weightLb, ounces: weightOz };
		const dimensions = {
			length,
			width,
			height,
		};

		return (
			<div className="common-rate-advisor-header">
				<ShippingInputs shipFrom={shipFrom} shipTo={shipTo} />
				<WeightField
					weight={weight}
					onChange={this.onChangeWeight}
					doValidation={false}
				/>
				<DimensionsField
					dimensions={dimensions}
					onChange={this.onChangeDimensions}
					doValidation={false}
				/>
				{!dimensions.length || !dimensions.width || !dimensions.height ? (
					<div className="dimensions-empty-info-panel">
						<div className="dimensions-empty-info-text">
							Enter dimensions for more accurate results.
						</div>
					</div>
				) : null}
			</div>
		);
	}
}

export default Header;
